import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 3rem 2rem 4rem;
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 8px;
  margin-bottom: 40px;
  .h1 {
    line-height: 67px;
  }

  .subtitle {
    width: 100%;
  }

  @media ${(props) => props.theme.device.laptop} {
    flex-direction: column;
    align-items: flex-start;
    gap: 14px;

    .subtitle {
      order: 2;
    }

    .h1 {
      line-height: unset;
    }
  }
`;

export const LiveEventsBox = styled.div`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 20px 24px;
  background-color: ${({ theme }) => theme.colors.bgBox};

  @media ${(props) => props.theme.device.laptop} {
    order: 3;
  }

  @media ${(props) => props.theme.device.tabletL} {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const SupervisorBox = styled(LiveEventsBox)`
  margin-top: -16px;
  justify-content: space-between;

  @media ${(props) => props.theme.device.mobileL} {
    margin-top: 24px;
  }
`;

export const FiltersContainer = styled.div`
  width: 100%;
  margin-bottom: 32px;
  margin-top: 32px;
`;

export const Filter = styled.div`
  min-width: 115px;
  width: fit-content;

  & > div:first-child {
    margin-bottom: 10px;
  }

  & .level {
    &.l-1::before {
      content: '-';
      margin-right: 4px;
    }
    &.l-2::before {
      content: '-';
      margin-right: 4px;
      margin-left: 10px;
    }
    &.l-3::before {
      content: '-';
      margin-right: 4px;
      margin-left: 20px;
    }
    &.l-4::before {
      content: '-';
      margin-right: 4px;
      margin-left: 30px;
    }
  }
`;

export const SelectsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;

  @media (min-width: 1280px) {
    justify-content: unset;
  }

  @media ${(props) => props.theme.device.tabletL} {
    width: 100%;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
    flex-direction: column;
  }
`;

export const TabsContainer = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;

  // Filter Tabs on two row and center alignment
  > div {
    max-width: 70%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    @media ${(props) => props.theme.device.tabletL} {
      max-width: 100%;
    }

    > div {
      margin-bottom: 10px;
    }
  }

  @media ${(props) => props.theme.device.tabletL} {
    text-align: center;
  }
`;

export const CoursesContainer = styled.div`
  padding-bottom: 4rem;
  display: grid;
  gap: 28px;
  grid-template-columns: 1fr 1fr 1fr;

  @media ${(props) => props.theme.device.laptop} {
    grid-template-columns: 1fr 1fr;
  }
  @media ${(props) => props.theme.device.tabletL} {
    grid-template-columns: 1fr 1fr;
  }
  @media ${(props) => props.theme.device.mobileM} {
    grid-template-columns: 1fr;
  }
`;

export const CourseItem = styled.div`
  @media screen and (min-width: 1280px) {
    & > div {
      margin: 0;
    }
  }
`;

export const ViewMore = styled.div``;

export const ResultsSorting = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 40px;

  .found-results {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    color: ${({ theme }) => theme.colors.black};
  }
`;

export const PageWrapper = styled.div`
  display: none;

  &.active {
    display: block;
  }
`;

export const Legend = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 90px max(300px, 33%) 1fr 1fr 120px 100px 30px;
  gap: 10px;
  text-transform: uppercase;
  padding: 0 24px;
  width: calc(100% - 20px);
  margin: 0 auto 24px;
  color: ${({ theme }) => theme.colors.textSecondary};

  .h3-5 {
    font-size: 14px;
  }
`;

const eventGrid = '90px 1fr 120px 1fr 120px 1fr 100px 30px';
export const EventLegend = styled(Legend)`
  grid-template-columns: ${eventGrid};
`;

export const CourseCard = styled(Legend)`
  color: ${({ theme }) => theme.colors.textPrimary};
  text-transform: unset;
  margin-bottom: 8px;
  padding: 24px;
  padding-left: 32px;
  border-radius: 4px;
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);

  .category {
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  &.last {
    margin-bottom: 64px;
  }

  @media ${(props) => props.theme.device.tabletL} {
    padding: 16px 0;
    margin-bottom: 0;
    width: 100%;
    grid-template-columns: 200px 1fr;
    row-gap: 16px;
    box-shadow: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};

    > h5:nth-child(odd) {
      text-transform: uppercase;
      color: #646464;
    }
    > *:nth-child(even) {
      text-align: right;
    }

    .btns-wrapper {
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: end;
      gap: 32px;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    grid-template-columns: 100px 1fr;
  }
`;

export const EventCard = styled(CourseCard)`
  grid-template-columns: ${eventGrid};

  @media ${(props) => props.theme.device.tabletL} {
    padding: 16px 0;
    margin-bottom: 0;
    width: 100%;
    grid-template-columns: 200px 1fr;
    row-gap: 16px;
    box-shadow: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};

    > h5:nth-child(odd) {
      text-transform: uppercase;
      color: #646464;
    }
    > *:nth-child(even) {
      text-align: right;
    }

    .btns-wrapper {
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: end;
      gap: 32px;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    grid-template-columns: 100px 1fr;
  }
`;
